import { sfAnd, sfEqual, sfNotEqual, sfOr } from 'spring-filter-query-builder';
import { ActivityStatusCode } from '../../api/dto';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const INACTIVE_ACTIVITY_STATUSES: Set<string> = new Set([
    ActivityStatusCode.NEW,
    ActivityStatusCode.CLOSED,
    ActivityStatusCode.REJECTED,
    ActivityStatusCode.CANCELLED,
    ActivityStatusCode.FINISHED,
]);

export const makeActivityDefaultFilter = (searchValue: string): string => {
    const trimmedSearch = searchValue.trim();
    const escapedSearchValue = escapeSfqbString(trimmedSearch, true);
    const words = escapedSearchValue.split(/[^a-zA-Z0-9]+/).filter((word) => word.length > 0);

    const idSearch = sfLike('id', `${escapedSearchValue}*`, true);

    if (words.length === 0) return idSearch.toString();

    const titleMatches = words.map((word) => sfLike('title', `*${word}*`, true));
    const titleSearch = sfAnd(titleMatches);

    return sfOr([titleSearch, idSearch]).toString();
};

export const makeActivityIdFilter = (searchValue: string): string =>
    sfLike('id', `${escapeSfqbString(searchValue, true)}*`, true).toString();

export const makeActiveOrDraftActivityIdFilter = (searchValue: string): string =>
    sfAnd([
        sfLike('id', `${escapeSfqbString(searchValue, true)}*`, true),
        sfOr([
            // There is a bug with SFQB "not" operator, therefore we use that instead
            sfAnd(Array.from(INACTIVE_ACTIVITY_STATUSES).map((code) => sfNotEqual('status.code', code))),
            sfEqual('status.code', ActivityStatusCode.DRAFT),
        ]),
    ]).toString();

export const makeAccessPointDefaultFilter = (searchValue: string): string =>
    sfLike('name', `${escapeSfqbString(searchValue, true)}*`, true).toString();

export const makeTagsDefaultFilter = (searchValue: string): string =>
    sfLike('name', `*${escapeSfqbString(searchValue, true)}*`, true).toString();

export const buildInterventionPeriodDefaultFilter = (searchValue: string) =>
    sfLike('periodName', `*${escapeSfqbString(searchValue, true)}*`, true);

export const makeInterventionPeriodDefaultFilter = (searchValue: string): string =>
    buildInterventionPeriodDefaultFilter(searchValue).toString();
